export enum DocumentDetailFieldStatusEnum {
  INITIAL = 'INITIAL',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  EXPIRED = 'EXPIRED',
  NO_BAR_CODE_DATA = 'NO_BAR_CODE_DATA',
}
